export default __webpack_public_path__ + "static/media/041-radiation.648554d0.png";